export default {
    client: "Cliente",
    country: "País",
    in_case_of_doubts_about_the_operation_of_the_platform_points_or_any_information_not_related_to_the_content_of_the_courses_fill_out_the_form_to_contact_our_support_team_our_response_time_is_7_working_days: "Em caso de dúvidas sobre o funcionamento da plataforma, pontos, ou qualquer informação, preencha o formulário para entrar em contato com nossa equipe de suporte.",
    subject: "Assunto"
}